<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" />
        <h2 id="pageTitle">{{ 'bss.request.error.title' | translate }}</h2>
        <hr style="margin-top: 10px; margin-bottom: 0px;">

        <div class="ontario-column ontario-small-12">
            <div class="ontario-alert ontario-alert--error">
                <div class="ontario-alert__header">
                    <div class="ontario-alert__header-icon">
                        <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false"
                            sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-error"></use>
                        </svg>
                    </div>
                    <div>
                        <h2 class="ontario-alert__header-title ontario-h4" *ngIf="code">
                            {{'bss.request.error.code.title' | translate }} {{ code }}
                        </h2>
                        <h2 class="ontario-alert__header-title ontario-h4" *ngIf="!code">
                            {{'bss.pki.error.message.title' | translate }}
                        </h2>
                        <b><p>{{errorMsgKey | translate }}</p></b>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="ontario-row" *ngIf="code === '16'">
    <div class="ontario-column ontario-small-12">
        <button tabindex="101" (click)="onSubmit()" class="ontario-button ontario-button--primary" title="{{ 'bss.logout.signIn.title' | translate }}">
            {{ 'bss.logout.signIn' | translate }}
        </button>      
    </div>
</div>
